import { EditGridView } from '../../../types/edit-grid';

export const updateGridSize = (view: EditGridView) => {
    const { state, update } = view;
    const lastRowWithItem = Math.max(
        0,
        state.grid.products.length - 1 - state.grid.products.reverse().findIndex((row) => row.some((item) => item))
    );
    state.grid.products.reverse();

    state.grid.products = state.grid.products.slice(0, lastRowWithItem + 1);
    state.grid.products.push(Array(6).fill(null));
    state.grid.products.push(Array(6).fill(null));
};

export const openProductModal = (view: EditGridView, row: number, col: number) => {
    const { state, update } = view;

    const gridItem = state.grid.products[row][col];
    if (gridItem) {
        state.editModal = {
            row,
            col,
            data: { ...gridItem },
        };
    } else {
        // Check if there are any products with variants available
        const defaultVariantId =
            state.products.products.length > 0 && state.products.products[0].variants.length > 0
                ? state.products.products[0].variants[0].id
                : undefined;

        state.editModal = {
            row,
            col,
            data: {
                title: '',
                variantId: defaultVariantId,
                color: 'pink',
                active: true,
            },
        };
    }

    update();
};
